import React from 'react';
import StatusBadge from './StatusBadge';
import ActionButtons from './ActionButtons';
import { ModuleType } from '../../../api/modules.types';
import ActivateApi from '../../../api/genericApis/Activate.api';
import Swal from 'sweetalert2';
import DeactivateApi from '../../../api/genericApis/Deactivate.api';
import DeleteForEverApi from '../../../api/genericApis/DeleteForever.api';

interface ServiceCardProps {
  title: string;
  city: string;
  imageUrl: string;
  status: boolean;
  editRoute: string;
  moduleType: ModuleType;
  id: number;
  getList: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  city,
  imageUrl,
  status,
  editRoute,
  moduleType,
  id,
  getList,
}) => {
  const onActivate = async () => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to activate this ${moduleType}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, activate it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        ActivateApi({ moduleType: moduleType, id })
          .then((response) => {
            Swal.fire({
              title: 'Activated!',
              text: `The ${moduleType} has been successfully activated.`,
              icon: 'success',
              confirmButtonText: 'Ok',
            });
            getList(); // Refresh the list after activation
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error!',
              text: `There was an issue activating the ${moduleType}. Please try again.`,
              icon: 'error',
              confirmButtonText: 'Ok',
            });
            console.log(error);
          });
      }
    });
  };

  const onDeactivate = async () => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to deactivate this ${moduleType}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, deactivate it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        DeactivateApi({ moduleType: moduleType, id })
          .then((response) => {
            Swal.fire({
              title: 'Deactivated!',
              text: `The ${moduleType} has been successfully deactivated.`,
              icon: 'success',
              confirmButtonText: 'Ok',
            });
            getList(); // Refresh the list after deactivation
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error!',
              text: `There was an issue deactivating the ${moduleType}. Please try again.`,
              icon: 'error',
              confirmButtonText: 'Ok',
            });
            console.log(error);
          });
      }
    });
  };

  const onDeleteForever = async () => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete this ${moduleType} forever?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteForEverApi({ moduleType: moduleType, id })
          .then((response) => {
            Swal.fire({
              title: 'Delete!',
              text: `The ${moduleType} has been successfully Delete.`,
              icon: 'success',
              confirmButtonText: 'Ok',
            });
            getList(); // Refresh the list after deactivation
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error!',
              text: `There was an issue deleting the ${moduleType}. Please try again.`,
              icon: 'error',
              confirmButtonText: 'Ok',
            });
            console.log(error);
          });
      }
    });
  };

  return (
    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 my-4 min-h-100">
      <div className="d-flex flex-column h-100">
        <div>
          <img
            src={imageUrl}
            alt={title}
            style={{
              width: '100%',
              maxHeight: '205px',
              objectFit: 'fill',
            }}
          />
        </div>
        <div
          className="flex-grow-1"
          style={{ overflow: 'hidden', paddingBottom: '10px' }}
        >
          <h5>{title}</h5>
          <p>{city}</p>
        </div>
        <div className="mt-2">
          <StatusBadge isActive={status} />
        </div>
        <div className="mt-auto">
          <ActionButtons
            isActive={status}
            onActivate={onActivate}
            onDeactivate={onDeactivate}
            onDeleteForever={onDeleteForever}
            editRoute={editRoute}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
